import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { createInterval } from 'src/app/utils/utils';

type LSTime = { hours: string, minutes: string, seconds: string }

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.css']
})
export class TimerComponent implements OnInit {

  @Output() enableBtn = new EventEmitter<boolean>()

  showSeconds: string = '00'
  showMinutes: string = '00'
  showHours: string = '00'
  showTime: string = '00:00:00'
  seconds: number = 0
  minutes: number = 0
  hours: number = 0
  interval: any = null

  constructor() {
    const timeFromLS: LSTime = JSON.parse(localStorage.getItem('time') || null)

    if (timeFromLS === null) return

    const {hours, minutes, seconds} = timeFromLS

    this.showSeconds = seconds
    this.showMinutes = minutes
    this.showHours = hours
    this.showTime = `${hours}:${minutes}:${seconds}`

    this.hours = parseInt(hours)
    this.minutes = parseInt(minutes)
    this.seconds = parseInt(seconds)
  }

  ngOnInit() {
    createInterval(1000, () => this.changeTime())
  }

  private saveTimeToLS(time: LSTime): void {
    localStorage.setItem('time', JSON.stringify(time))
  } 

  public changeTime(): void {
    if (this.seconds > 58) {
      this.seconds = 0
      this.minutes++
      this.showMinutes = this.minutes.toString().length === 1 ? `0${this.minutes}` : this.minutes.toString()
      this.showSeconds = '00'
    } else {
      this.seconds++
      this.showSeconds = this.seconds.toString().length === 1 ? `0${this.seconds}` : this.seconds.toString()
    }

    if (this.minutes > 58) {
      this.minutes = 0
      this.hours++
      this.showHours = this.hours.toString().length === 1 ? `0${this.hours}` : this.hours.toString()
      this.showMinutes = '00'
    }

    if (this.minutes > 0) {
      this.enableBtn.emit(true)
    }

    this.showTime = `${this.showHours}:${this.showMinutes}:${this.showSeconds}`
    this.saveTimeToLS({ hours: this.showHours, minutes: this.showMinutes, seconds: this.showSeconds })
  }
}
